import React from "react";
import moment from "moment";
import { Link } from 'react-router-dom';
import { Col, Row, Button, Input } from "reactstrap";
import ToolkitProvider, {
  CSVExport
} from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import { useTranslation } from "react-i18next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

const DeliveryConfirmationTable = ({ tableData, searchQuery }) => {
  const { ExportCSVButton } = CSVExport;
  const { t } = useTranslation();

  const statusFormatter = cell => {
    return (
      <>
        {cell === "PARTIALLY DELIVERED" ? (
          <Button className="btn-status" disabled color="warning">
            {t("deliveryConfirmation.view.table.label.statusPartially")}
          </Button>
        ) : cell === "DELIVERED" ? (
          <Button className="btn-status" disabled color="primary">
            {t("deliveryConfirmation.view.table.label.statusDelivered")}
          </Button>
        ) : (
          <Button className="btn-status" disabled color="danger">
            {t("deliveryConfirmation.view.table.label.statusUndelivered")}
          </Button>
        )}
      </>
    );
  };

  const ddexActionFormatter = cell => {
    return (
      <>
        {cell === "INSERT" ? (
          <Button className="btn-status" disabled color="primary">
            {t("deliveryConfirmation.view.table.label.ddexActionInsert")}
          </Button>
        ) : cell === "FULL_UPDATE" ? (
          <Button className="btn-status" disabled color="info">
            {t("deliveryConfirmation.view.table.label.ddexActionFullUpdate")}
          </Button>
        ) : cell === "METADATA_UPDATE" ? (
          <Button className="btn-status" disabled color="secondary">
            {t("deliveryConfirmation.view.table.label.ddexActionMetadataUpdate")}
          </Button>
        ) : cell === "TAKEDOWN" ? (
          <Button className="btn-status" disabled color="danger">
            {t("deliveryConfirmation.view.table.label.ddexActionTakedown")}
          </Button>
        ) : (
          <></>
        )}
      </>
    );
  };

  const actionFormatter = (cell, row) => {
    return (
      <Link to={`/delivery-list/${row.id}/view`} className="btn btn-outline-primary">{t("deliveryConfirmation.view.table.button.open")}</Link>
    );
  };

  const releaseFormatter = (cell, row) => {
    const SRC = row.release_artwork ? row.release_artwork.thumb_small : null;
    return (
      <div className="flexContainer">
        {SRC && <img style={{width: 40, height: 40, borderRadius: '100%'}} src={SRC} alt={cell}/> }
        <p className="fontWeight700">{cell}</p>
      </div>
    );
  };

  const dateFormatter = (cell, row) => {
    return (
      moment(cell).format('YYYY-MM-DD')
    );
  };

  const columns = [
    {
      dataField: "release_name",
      text: t("deliveryConfirmation.view.table.columns.release"),
      sort: false,
      csvExport: true,
      formatter: releaseFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "60px" };
      }
    },
    {
      dataField: "upc",
      text: t("deliveryConfirmation.view.table.columns.upc"),
      sort: false,
      csvExport: true,
      headerStyle: (colum, colIndex) => {
        return { width: "60px" };
      }
    },
    {
      dataField: "action",
      text: t("deliveryConfirmation.view.table.columns.action"),
      formatter: ddexActionFormatter,
      sort: false,
      csvExport: true,
      headerStyle: (colum, colIndex) => {
        return { width: "60px" };
      }
    },
    {
      dataField: "status",
      text: t("deliveryConfirmation.view.table.columns.status"),
      formatter: statusFormatter,
      sort: true,
      csvExport: true,
      headerStyle: (colum, colIndex) => {
        return { width: "60px" };
      }
    },
    {
      dataField: "created",
      text: t("deliveryConfirmation.view.table.columns.deliveryDate"),
      formatter: dateFormatter,
      csvFormatter: dateFormatter,
      sort: true,
      csvExport: true,
      headerStyle: (colum, colIndex) => {
        return { width: "60px" };
      },
    },
    {
      dataField: "open",
      text: t("deliveryConfirmation.view.table.columns.details"),
      formatter: actionFormatter,
      sort: false,
      csvExport: false,
      headerStyle: (colum, colIndex) => {
        return { width: "20px" };
      }
    }
  ];

  return (
    <ToolkitProvider
      keyField="id"
      data={tableData}
      columns={columns}
      search={{
        searchFormatted: true
      }}
      exportCSV={{
        fileName: 'release-delivery-list.csv',
      }}
    >
      {props => (
        <div>
          <Row>
            <Col>
              <div className="customSearch">
                 <Input placeholder={t("deliveryConfirmation.view.table.placeholder.search")}  value={searchQuery.query} style={{marginBottom: 10}} onChange={e => searchQuery.setQuery(e.target.value)} />
              </div>
            </Col>
            <Col>
              <div className="flexEndContainer">

                <ExportCSVButton
                  className="btn btn-outline-info"
                  {...props.csvProps}
                >
                  {t("deliveryConfirmation.view.table.button.exportCSV")}
                </ExportCSVButton>
              </div>
            </Col>
          </Row>

          <BootstrapTable
            {...props.baseProps}
            bordered={ false }
            remote={ { sort: false } }
          />
        </div>
      )}
    </ToolkitProvider>
  );
};

export default DeliveryConfirmationTable;